import ContentMarquee from '@publishing/modules/marquee/ContentMarquee';
import type {
  CarouselTabsDirection,
  CarouselTabsTab,
  CarouselTabsTheme,
} from './types';
import { TabSlide, getSlideKey } from './TabSlide';
import s from './CarouselTabsSection.module.scss';

export function RollingSlides({
  tab,
  direction,
  theme,
}: {
  tab: CarouselTabsTab;
  direction: CarouselTabsDirection;
  theme: CarouselTabsTheme;
}) {
  const isSingleSlide = tab.images.length === 1;
  return (
    <div className={direction === 'row' ? s.rolling_row_clip : undefined}>
      {isSingleSlide ? (
        <TabSlide
          image={tab.images[0]}
          index={0}
          tab={tab}
          theme={theme}
          imageClassName={s.carousel_rolling_image}
        />
      ) : (
        <ContentMarquee
          duration={tab.images.length * 4}
          mobileDuration={tab.images.length * 3}
        >
          {tab.images.map((image, index) => (
            <TabSlide
              key={getSlideKey(image, tab.alt, index)}
              image={image}
              index={index}
              tab={tab}
              theme={theme}
              imageClassName={s.carousel_rolling_image}
            />
          ))}
        </ContentMarquee>
      )}
    </div>
  );
}
